<template>
  <footer class="border-t border-slate-200 bg-white">
    <div class="marketing-shell py-16">

      <!-- Main footer grid -->
      <div class="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:grid-cols-5">

        <!-- Brand column -->
        <div class="col-span-2 sm:col-span-3 lg:col-span-2">
          <div class="flex items-center gap-2.5">
            <div class="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-600">
              <span class="text-xs font-bold text-white">贝</span>
            </div>
            <span class="text-sm font-bold text-slate-900">贝易科技</span>
          </div>
          <p class="mt-4 max-w-[240px] text-xs leading-6 text-slate-500">
            武汉贝易科技有限公司 — 专注企业级智能数据管理，提供私有化部署与 SaaS 租户服务，助力企业数字化转型。
          </p>
          <div class="mt-6 flex gap-2">
            <a
              href="mailto:beibei@beiyidata.cn"
              class="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900"
            >
              <PhEnvelopeSimple :size="14" /> 发邮件咨询
            </a>
          </div>
        </div>

        <!-- Products column -->
        <div>
          <p class="mb-4 text-xs font-semibold uppercase tracking-widest text-slate-700">产品</p>
          <ul class="space-y-2.5">
            <li v-for="item in footerProducts" :key="item.label">
              <a :href="item.href" class="text-xs text-slate-500 transition-colors hover:text-slate-700">
                {{ item.label }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Solutions column -->
        <div>
          <p class="mb-4 text-xs font-semibold uppercase tracking-widest text-slate-700">解决方案</p>
          <ul class="space-y-2.5">
            <li v-for="item in footerSolutions" :key="item.label">
              <a :href="item.href" class="text-xs text-slate-500 transition-colors hover:text-slate-700">
                {{ item.label }}
              </a>
            </li>
          </ul>
        </div>

        <!-- About + Contact -->
        <div>
          <p class="mb-4 text-xs font-semibold uppercase tracking-widest text-slate-700">关于</p>
          <ul class="space-y-2.5">
            <li>
              <a href="/#about" class="text-xs text-slate-500 transition-colors hover:text-slate-700">公司简介</a>
            </li>
            <li>
              <a href="/#contact" class="text-xs text-slate-500 transition-colors hover:text-slate-700">联系我们</a>
            </li>
            <li>
              <a href="mailto:beibei@beiyidata.cn" class="text-xs text-slate-500 transition-colors hover:text-slate-700">商务合作</a>
            </li>
          </ul>
          <p class="mb-3 mt-8 text-xs font-semibold uppercase tracking-widest text-slate-700">联系方式</p>
          <div class="space-y-2">
            <a href="tel:+8618689473997" class="flex items-center gap-2 text-xs text-slate-500 transition-colors hover:text-blue-600"><PhPhone :size="14" aria-hidden="true" /> +86 18689473997</a>
            <p class="flex items-center gap-2 text-xs text-slate-500"><PhEnvelopeSimple :size="14" /> beibei@beiyidata.cn</p>
            <p class="flex items-center gap-2 text-xs text-slate-500"><PhMapPin :size="14" /> 武汉市</p>
          </div>
        </div>

      </div>

    </div>

    <!-- Bottom bar -->
    <div class="border-t border-slate-200">
      <div class="marketing-shell flex flex-col items-center justify-between gap-3 py-5 sm:flex-row">
        <p class="text-xs text-slate-600">
          © {{ new Date().getFullYear() }} 武汉贝易科技有限公司. All rights reserved. &nbsp;|&nbsp; 鄂ICP备2025119742号
        </p>
        <div class="flex items-center gap-4">
          <a
            href="https://beiyidata.cn/beibeibudget/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-xs text-slate-600 transition-colors hover:text-slate-600"
          >
            隐私政策
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { PhPhone, PhEnvelopeSimple, PhMapPin } from '@phosphor-icons/vue'
import { visibleEnterpriseProducts } from '../data/products'
const footerProducts = visibleEnterpriseProducts.map((product) => ({
  label: product.name.zh, href: `/products/${product.id}`,
}))

const footerSolutions = [
  { label: '央国企', href: '/solutions/enterprise' },
  { label: '智慧政务', href: '/solutions/government' },
  { label: '能源电力', href: '/solutions/energy' },
  { label: '智能制造', href: '/solutions/manufacturing' },
]
</script>
